import React, { useRef, useState, useEffect } from "react";
import loadImage from "blueimp-load-image";
import ReactPlayer from "react-player";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../Constants/types";
const MediaUpload = ({
  onChangeContent,
  contentUrl,
  contentType,
  defaultLoad = false,
}) => {
  const [content, setContent] = useState(null);
  const [filePath, setFilePath] = useState(null);
  const [mediaType, setMediaType] = useState();
  const imageButton = useRef();
  useEffect(() => {
    if (content) onChangeContent(content, mediaType);
  }, [content, mediaType]);
  useEffect(() => {
    if (contentUrl && contentUrl !== "") {
      setFilePath(contentUrl);
    }
  }, [contentUrl]);
  useEffect(() => {
    if (contentType && contentType !== "") {
      setMediaType(contentType);
    }
  }, [contentType]);
  useEffect(() => {
    if (!defaultLoad) return;
    if (imageButton.current === null) return;
    imageButton.current.click();
  }, [imageButton]);
  const selectFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      setFilePath(URL.createObjectURL(content));
      if (content.type === "image/jpeg" || content.type === "image/png") {
        setMediaType(IMAGE_UPLOAD);
        const type = content.type;
        loadImage.parseMetaData(content, function (data) {
          var orientation = 0;
          if (data.exif) {
            orientation = data.exif.get("Orientation");
          }
          loadImage(
            content,
            function (canvas) {
              var base64data = canvas.toDataURL(type);
              var img_src = base64data.replace(
                /^data\:image\/\w+\;base64\,/,
                ""
              );
              setContent(img_src);
              let img_content = "data:" + type + ";base64," + img_src;
              setFilePath(img_content);
            },
            {
              canvas: true,
              orientation: orientation,
            }
          );
        });
      } else if (content.type === "image/gif") {
        setMediaType(GIF_UPLOAD);
        setContent(content);
      } else if (content.type === "video/mp4") {
        setMediaType(VIDEO_UPLOAD);
        setContent(content);
      }
    }
  };
  return (
    <React.Fragment>
      <div
        className="col-12"
        style={
          defaultLoad
            ? { display: "none" }
            : { display: "flex", alignItems: "center" }
        }
      >
        <label htmlFor="image">Upload Media &nbsp; </label>
        <input
          ref={imageButton}
          type="file"
          id="image"
          name="image"
          accept="image/gif, image/jpeg, image/png, video/mp4"
          className="form-control-file"
          style={{ display: "none" }}
          onChange={selectFile}
        />
        <button
          className="btn btn-green"
          onClick={() => imageButton.current.click()}
        >
          Choose Media
        </button>
        <p style={{ fontSize: "14px", position: "absolute", right: "0px" }}>
          Select a square gif, jpg or video
        </p>
      </div>
      <div>
        {filePath &&
          (mediaType === VIDEO_UPLOAD ? (
            <div className="flex-center mt-3">
              <ReactPlayer
                url={filePath}
                width="150px"
                height="150px"
                controls={true}
              />
            </div>
          ) : (
            <div className="flex-center mt-3">
              <img
                src={filePath}
                alt="post_img"
                style={{
                  height: "150px",
                  width: "150px",
                }}
              />
            </div>
          ))}
      </div>
    </React.Fragment>
  );
};
export default MediaUpload;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/MediaUpload.js